module.exports = __webpack_public_path__ + "img/Wassergefälle.7cf81ed3.svg";